import { resolveActivePromoCampaignFromList } from './resolve-active-promo-campaign';
import { septFlash48PromoCampaign } from './sept-flash-48';
import type { ActivePromoCampaign, PromoCampaignContext, RegisteredPromoCampaign } from './types';

export { resolveActivePromoCampaignFromList } from './resolve-active-promo-campaign';

export const PROMO_CAMPAIGNS: RegisteredPromoCampaign[] = [septFlash48PromoCampaign];

export function resolveActivePromoCampaign(ctx: PromoCampaignContext): ActivePromoCampaign | null {
  return resolveActivePromoCampaignFromList(PROMO_CAMPAIGNS, ctx);
}
